export enum HeroLayout {
  LAYOUT1 = 'hero_layout1',
  LAYOUT2 = 'hero_layout2',
  LAYOUT3 = 'hero_layout3',
  LAYOUT4 = 'hero_layout4',
}
